import { FormControl, FormArray, FormGroup, Validators } from "@angular/forms";
import { MyUtils } from "src/app/services/my-utils.service";

export interface DataMiningDialogData {
    surveyId: string;
    completedDate: string;
    outletId: string;
    isEdit: boolean;
    title: string;
    description: string;
    dateEnd: Date | string;
    additionalInformation?: { additionalInfo: string; type: number }[];
    attach?: boolean;
    brand?: string;
    region?: string;
    recoveryPlanId?: string;
    contactReasonL1: string;
    contactReasonL2: string;
    dissatisfacionReason1Level1: string;
    dissatisfacionReason1Level2: string;
    dissatisfacionReason2Level1?: string;
    dissatisfacionReason2Level2?: string;
    personEnteringInfo?: string;
    closed?: boolean
}

export class DataMiningFormBuilder {
    form: FormGroup;

    constructor(private data: DataMiningDialogData,
        private utils: MyUtils) {

        this.form = this.initForm();
        // this.addAdditionalInformationForm()
    }

    initForm(): FormGroup {
        const form: FormGroup = new FormGroup({
            contactReason: new FormGroup({
                categoryLevel1: new FormControl('',Validators.required),
                categoryLevel2: new FormControl({value: '',disabled: true},Validators.required)
            }),
            dissatisfactionReason1: new FormGroup({
                categoryLevel1: new FormControl('',Validators.required),
                categoryLevel2: new FormControl({value: '',disabled: true},Validators.required)
            }),
            dissatisfactionReason2: new FormGroup({
                categoryLevel1: new FormControl(''),
                categoryLevel2: new FormControl({value: '',disabled: true})
            }),
            personEnteringInfo: new FormControl(localStorage.getItem("email")),
            description: new FormControl(this.data.description ?? '',Validators.required),
            surveyId: new FormControl(this.data.surveyId),
            surveyDate: new FormControl(this.utils.parseEuropeanDate(this.data.completedDate)),
            outletId: new FormControl(this.data.outletId),
            dateStart: new FormControl(new Date()),
        });
        form.controls['personEnteringInfo'].disable();
        form.controls['surveyId'].disable();
        form.controls['surveyDate'].disable();
        form.controls['outletId'].disable();
        if (this.data.isEdit) form.controls['dateStart'].disable();

        return form;
    }
}
